import {ToolExecuteParams, ToolResult} from 'common/src/modules/shared/copilot/copilot.types';
import tool from 'common/src/modules/shared/copilot/utils/creators/tool';
import toolResult from 'common/src/modules/shared/copilot/utils/creators/toolResult';
import {CLStore} from 'common/src/redux/store';
import {z} from 'zod';
import {showPreviewForTemplateId} from '../../../../store/creativeTemplatesLibrary/creativeTemplatesLibrary.slice';
import {CreativeTemplatesManagerAgentToolName} from '../creativeTemplatesManagetAgent.enums';

function showCreativeTemplatePreviewTool(store: CLStore) {
  const inputSchema = z.object({
    templateId: z.number().describe('The ID of the template to show preview for'),
  });

  async function execute({
    input: {templateId},
  }: ToolExecuteParams<typeof inputSchema>): Promise<ToolResult> {
    const templates = store.getState().creativeTemplatesLibrary.templates;
    inputSchema;
    const isTemplateIdValid = templates.some((template) => template.id === templateId);

    if (!isTemplateIdValid) {
      return toolResult(
        `Template with ID ${templateId} not found in the creative templates library.`,
      );
    }

    store.dispatch(showPreviewForTemplateId(templateId));

    return toolResult('Showing preview for template ID: ' + templateId);
  }

  return tool({
    name: CreativeTemplatesManagerAgentToolName.ShowCreativeTemplatePreview,
    description:
      'Show the preview of given template ID. Must navigate to creative templates library first',
    displayName: 'Showing creative template preview',
    execute,
    inputSchema,
  });
}

export default showCreativeTemplatePreviewTool;
